import { IconProps } from '.';

const FlagIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 30 33"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.414062 0.583008H14.9974C15.4365 0.583008 15.8434 0.813381 16.0693 1.18989L18.2051 4.74967H28.3307C29.0211 4.74967 29.5807 5.30932 29.5807 5.99967V24.333C29.5807 25.0234 29.0211 25.583 28.3307 25.583H18.3307C17.8917 25.583 17.4848 25.3526 17.2589 24.9761L15.123 21.4163H2.91406V32.6663H0.414062V0.583008ZM2.91406 18.9163H16.5385L19.0385 23.083H27.0807V7.24967H16.7897L14.2897 3.08301H2.91406V18.9163Z"
        fill={color || 'var(--color-ui-icon-primary)'}
      />
    </svg>
  );
};

export default FlagIcon;
